export const getId = (obj) => obj?._id || obj?.id || `${obj}`;

// يبني مُقتطف نصي قصير من HTML كامل (يحذف الصور base64 والوسوم) لتفادي تضخيم حجم الصفحة
export const htmlToExcerpt = (html, maxLength = 200) => {
  if (!html) return "";
  const withoutImages = String(html).replace(/<img[^>]*>/gi, "");
  const text = withoutImages
    .replace(/<[^>]+>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  return text.length > maxLength
    ? `${text.slice(0, maxLength).trim()}…`
    : text;
};

// يحوّل قيمة مترجمة (ar/en) تحتوي HTML كامل إلى نفس الشكل لكن بمقتطف نصي قصير
const localizedExcerpt = (localized, maxLength) => {
  if (!localized || typeof localized !== "object") return localized;
  return Object.fromEntries(
    Object.entries(localized).map(([locale, html]) => [
      locale,
      htmlToExcerpt(html, maxLength),
    ])
  );
};

// يبني نسخة خفيفة من كائن المدونة لصفحات القوائم، بدون وصف HTML الكامل
// (الذي قد يحتوي صورًا مرفوعة كـ base64 ويُضاعف حجم الصفحة عند تسلسله ضمن __NEXT_DATA__)
export const mapBlogForListing = (blog, maxLength = 200) => ({
  id: blog?.id || blog?._id || null,
  title: blog?.title,
  image: blog?.image,
  category: blog?.category
    ? {
        id: blog?.category?.id || blog?.category?._id || null,
        title: blog?.category?.title || null,
      }
    : null,
  createdAt: blog?.createdAt,
  description: localizedExcerpt(blog?.description, maxLength),
});

export const handleImageLink = (image) => {
  if (image?.includes("http")) {
    return image;
  } else {
    return `${process.env.NEXT_PUBLIC_MAIN_URL}/${image}`;
  }
};

// ضع هذا الكود داخل نفس ملف الصفحة
const REDIRECTS_ENDPOINT = "https://alnojoom.ejjadh.info/api/seoRedirects";

// نظّف المسار: فك التشفير + إزالة ?query + إزالة / آخر المسار
function cleanPath(resolvedUrl = "") {
  try {
    const noQuery = String(resolvedUrl).split("?")[0] || "/";
    const decoded = decodeURI(noQuery);
    return decoded.length > 1 && decoded.endsWith("/")
      ? decoded.slice(0, -1)
      : decoded;
  } catch {
    const noQuery = String(resolvedUrl).split("?")[0] || "/";
    return noQuery.length > 1 && noQuery.endsWith("/")
      ? noQuery.slice(0, -1)
      : noQuery;
  }
}

// ابنِ Destination مطلق بدون أي Query Params
function toAbsoluteNoQuery(destRaw, req) {
  try {
    if (/^https?:\/\//i.test(destRaw)) {
      const u = new URL(destRaw);
      u.search = "";
      return u.toString();
    }
    const protocol =
      (req.headers["x-forwarded-proto"] || "").split(",")[0] ||
      (req.socket && req.socket.encrypted ? "https" : "http");
    const host = req.headers.host;
    const path = destRaw.startsWith("/") ? destRaw : `/${destRaw}`;
    return `${protocol}://${host}${path}`;
  } catch {
    return String(destRaw).split("?")[0];
  }
}

export async function checkRedirect(resolvedUrl, req) {
  const path = cleanPath(resolvedUrl);
  try {
    const res = await fetch(REDIRECTS_ENDPOINT, {
      headers: { Accept: "application/json" },
    });
    if (!res.ok) return null;

    const json = await res.json();
    const redirects = (json && json.data && json.data.seoRedirects) || [];

    const hit = redirects.find(
      (r) => r?.source && r?.destination && cleanPath(r.source) === path
    );
    if (!hit) return null;

    const permanent =
      String(hit.redirectCode) === "301" || String(hit.redirectCode) === "308";
    return {
      destination: toAbsoluteNoQuery(String(hit.destination).trim(), req),
      permanent,
    };
  } catch {
    return null;
  }
}
